module.exports = __webpack_public_path__ + "img/m1-screenshot-05_t.b050f5aa.jpg";